var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-template',{attrs:{"layout":"horizontal","title":"Name","show-device-picker":false}},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":_vm.name},on:{"input":_vm.changeName}})])}
var staticRenderFns = []

export { render, staticRenderFns }